export default {
  V3: 'v3',
  V4: 'v4'
};